import { render, staticRenderFns } from "./GastosEditar.vue?vue&type=template&id=04d9b20c"
import script from "./GastosEditar.vue?vue&type=script&lang=js"
export * from "./GastosEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports